import { ButtonVariant } from "@amzn/stencil-react-components/button";
import { Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { Button } from "@amzn/uxm-stencil-react-components/lib/src/stencil/button";
import {
  CFMModuleName,
  CustomerFeedback,
  CustomerFeedbackAlignment,
  CustomerFeedbackIconPosition,
  CustomerFeedbackMargins,
  CustomerFeedbackPopUpHeight,
} from "common/components";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

export const SearchBottomBar: FC = () => {
  return (
    <Row
      dataTestId="search-bottom-bar"
      backgroundColor="#F1F4F7"
      padding={"S300"}
      display="flex"
      className="search-bottom-bar"
      justifyContent="space-between"
      alignItems="center"
    >
      <View margin={["0", "0", "0", "S700"]} dataTestId="submit-software-request" display="flex" alignItems="center">
        <Text color="neutral90" fontSize="T14">
          {getString("submitSoftwareRequest.headerShort")}
        </Text>
      </View>
      <View dataTestId="submit-request-button">
        <Button
          variant={ButtonVariant.Tertiary}
          onClick={() => {
            window.open(getString("externalLinks.uniqueRequests"), "_blank");
          }}
          color="primary80"
          data-cy="submit-request-link"
          touchpoint="search-experience-submit-request-link"
        >
          {getString("submitSoftwareRequest.linkShort")}
        </Button>
      </View>
    </Row>
  );
};

export default SearchBottomBar;
